<div class="container">
  <div class="text-center">
    <h2>
      <strong class="mainHeading slide-in-left">Status Dashboard</strong>
    </h2>
  </div>

  <div class="row">
    <div class="col-md-2">
      <div class="card">
        <div
          class="card d-flex flex-column justify-content-center align-items-center text-center p-3"
        >
          <div>
            <strong><h1 class="mb-1">10</h1></strong>
          </div>
          <div>
            <h3 class="mb-0">City</h3>
          </div>
        </div>
      </div>
      <div class="card mt-3">
        <div
          class="card d-flex flex-column justify-content-center align-items-center text-center p-3"
        >
          <div>
            <strong><h1 class="mb-1">21</h1></strong>
          </div>
          <div>
            <h3 class="mb-0">Zones</h3>
          </div>
        </div>
      </div>
      <div class="card mt-3">
        <div
          class="card d-flex flex-column justify-content-center align-items-center text-center p-3"
        >
          <div>
            <strong><h1 class="mb-1">30</h1></strong>
          </div>
          <div>
            <h3 class="mb-0">Registered Users</h3>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-10">
      <div class="row">
        <div class="col-md-6">
          <div class="card position-relative">
            <div class="modal-header custom-modal-header">
              <h3 class="modal-title mt-3 ms-1">Individual Requestor</h3>
            </div>
            <div class="m-2 d-flex">
              <div class="me-2">
                <select
                  class="form-select"
                  aria-label="Select City"
                  (click)="onCityChange($event, 1)"
                >
                  <option value="">Select City</option>
                  <option *ngFor="let city of cityList" [value]="city.id">
                    {{ city.cityName }}
                  </option>
                </select>
              </div>

              <!-- Zone Select Box -->
              <div>
                <select
                  class="form-select"
                  aria-label="Select Zone"
                  (click)="onZoneChange($event)"
                >
                  <option selected>Select Zone</option>
                  <option
                    *ngFor="let zone of zoneListIndividual"
                    [value]="zone.zoneId"
                  >
                    {{ zone.zoneName }}
                  </option>
                </select>
              </div>
            </div>

            <!-- Chart -->
            <div id="chart">
              <apx-chart
                *ngIf="
                  individualChartOptions.series &&
                  individualChartOptions.series.length > 0
                "
                [series]="individualChartOptions.series"
                [chart]="individualChartOptions.chart"
                [dataLabels]="individualChartOptions.dataLabels"
                [stroke]="individualChartOptions.stroke"
                [colors]="individualChartOptions.colors"
                [title]="individualChartOptions.title"
                [subtitle]="individualChartOptions.subtitle"
                [plotOptions]="individualChartOptions.plotOptions"
                [yaxis]="individualChartOptions.yaxis"
                [xaxis]="individualChartOptions.xaxis"
                [tooltip]="individualChartOptions.tooltip"
              ></apx-chart>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <!-- Sidebar Content (2/12 columns) -->
      <div class="col-2">
        <div class="sidebar-content">Sidebar Content</div>
      </div>

      <!-- Main Content (10/12 columns) -->
      <div class="col-10">
        <div class="card">
          <div class="modal-header custom-modal-header">
            <h3 class="modal-title mt-3 ms-1">Completed Orders</h3>
          </div>
          <div class="m-2 d-flex">
            <!-- City Select Box -->
            <div class="me-2">
              <select
                class="form-select"
                aria-label="Select City"
                (click)="onCityChange($event, 2)"
              >
                <option selected>Select City</option>
                <option *ngFor="let city of cityList" [value]="city.id">
                  {{ city.cityName }}
                </option>
              </select>
            </div>

            <!-- Zone Select Box -->
            <div>
              <select
                class="form-select"
                aria-label="Select Zone"
                (click)="onZoneChange($event)"
              >
                <option selected>Select Zone</option>
                <option
                  *ngFor="let zone of zoneListCorporate"
                  [value]="zone.zoneId"
                >
                  {{ zone.zoneName }}
                </option>
              </select>
            </div>
          </div>

          <!-- Chart Container -->
          <div id="chart">
            <apx-chart
              *ngIf="
                orderChartOptions.series && orderChartOptions.series.length > 0
              "
              [series]="orderChartOptions.series"
              [chart]="orderChartOptions.chart"
              [dataLabels]="orderChartOptions.dataLabels"
              [stroke]="orderChartOptions.stroke"
              [colors]="orderChartOptions.colors"
              [title]="orderChartOptions.title"
              [subtitle]="orderChartOptions.subtitle"
              [plotOptions]="orderChartOptions.plotOptions"
              [yaxis]="orderChartOptions.yaxis"
              [xaxis]="orderChartOptions.xaxis"
              [tooltip]="orderChartOptions.tooltip"
            ></apx-chart>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
